(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection"]) return;
  try {
    
// Sort product grid by stock availability
document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.product-grid').forEach(function(grid) {
    var cards = Array.from(grid.querySelectorAll('.product-card'));
    cards.sort(function(a, b) {
      var aAvail = a.dataset.available === 'true' ? 1 : 0;
      var bAvail = b.dataset.available === 'true' ? 1 : 0;
      if (aAvail !== bAvail) return bAvail - aAvail;
      return parseInt(b.dataset.inventory || 0) - parseInt(a.dataset.inventory || 0);
    });
    cards.forEach(function(card) { grid.appendChild(card); });
  });
});

// Función global addToCart para páginas de colección.
// Delega a addProductToCartWithModal (definido en add-to-cart-modal.liquid,
// incluido globalmente en layout/theme.liquid).
if (!window.addToCart) {
  window.addToCart = function(variantId, quantity, button) {
    var recommendations = null;
    if (button && button.dataset && button.dataset.recommendations) {
      recommendations = button.dataset.recommendations.split(',').filter(Boolean);
    }
    if (typeof window.addProductToCartWithModal === 'function') {
      return window.addProductToCartWithModal(variantId, quantity, button, recommendations);
    } else {
      // Fallback: POST directo al carrito si el modal aún no está listo
      var formData = new FormData();
      formData.append('id', variantId);
      formData.append('quantity', quantity || 1);
      fetch('/cart/add.js', { method: 'POST', body: formData })
        .then(function() { window.location.href = '/cart'; })
        .catch(function() { window.location.href = '/cart'; });
    }
  };
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search"]) return;
  try {
    
if (!window.addToCart) {
  window.addToCart = function(variantId, quantity, button) {
    var recommendations = null;
    if (button && button.dataset && button.dataset.recommendations) {
      recommendations = button.dataset.recommendations.split(',').filter(Boolean);
    }
    if (typeof window.addProductToCartWithModal === 'function') {
      return window.addProductToCartWithModal(variantId, quantity, button, recommendations);
    }
  };
}

document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.product-card').forEach(function(card) {
    var link = card.querySelector('.product-title a');
    if (!link) return;
    var url = link.getAttribute('href');
    card.addEventListener('click', function(e) {
      if (e.target.closest('a, button, .product-review-trigger, .product-rating, [role="button"], input, label')) return;
      window.location.href = url;
    });
  });
});

  } catch(e) { console.error(e); }
})();
})();
